import clsx from 'clsx'

import { Button } from '@/shared/ui'

import cl from './create-preorder.module.scss'

interface CreatePreorderProps {
	className?: string
	size?: 'S' | 'M' | 'L'
	fullWidth?: boolean
	buttonName?: string
	onClick: () => Promise<void>
	isLoading?: boolean
}

export const CreatePreorder = (props: CreatePreorderProps) => {
	const { size = 'M', fullWidth, className, buttonName, onClick, isLoading = false } = props

	return (
		<Button
			theme="clear"
			onClick={onClick}
			size={size}
			fullWidth={fullWidth}
			className={clsx(cl.root, className)}
			isLoading={isLoading}>
			{buttonName ?? 'Купить'}
		</Button>
	)
}
